import * as React from 'react';
import { useGetCartExpressPaymentMethods } from './use-get-cart-express-payment-methods.js';

const useIsExpressPaymentMethodSupported = (paymentMethod)=>{
    const [getExpressPaymentMethods, { loading , called , data , error  }] = useGetCartExpressPaymentMethods();
    const fetchPaymentMethods = React.useCallback((cartId)=>{
        if (cartId) {
            getExpressPaymentMethods(cartId);
        }
    }, [
        getExpressPaymentMethods
    ]);
    const expressPaymentMethod = data === null || data === void 0 ? void 0 : data.find(({ name  })=>name === paymentMethod
    );
    return [
        fetchPaymentMethods,
        {
            isPaymentMethodSupported: Boolean(expressPaymentMethod),
            paymentConfiguration: expressPaymentMethod === null || expressPaymentMethod === void 0 ? void 0 : expressPaymentMethod.configuration,
            loading,
            called,
            error
        }, 
    ];
};

export { useIsExpressPaymentMethodSupported };
//# sourceMappingURL=use-is-express-payment-method-supported.js.map
